import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';

import AcceptFriendship from './AcceptFriendship/AcceptFriendship';


class NotificationsHeader extends Component {
  static propTypes = {
    closeNotifications: PropTypes.func,
    friendRequests: PropTypes.object,
    friendRequestsCounter: PropTypes.number,
    getFriendshipRequests: PropTypes.func,
    setFriendRequestsCounter: PropTypes.func,
    sfw: PropTypes.bool,
    updateFriendshipRequests: PropTypes.func,
  };

  static defaultProps = {
    closeNotifications: () => undefined,
    friendRequests: undefined,
    friendRequestsCounter: undefined,
    getFriendshipRequests: undefined,
    setFriendRequestsCounter: undefined,
    sfw: undefined,
    title: undefined,
    updateFriendshipRequests: undefined,
  };

  componentDidMount() {
    window.addEventListener('click', this.props.closeNotifications, true);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.props.closeNotifications, true);
  }

  render() {
    const {
      friendRequests,
      getFriendshipRequests,
      updateFriendshipRequests,
      setFriendRequestsCounter,
      friendRequestsCounter,
      sfw,
    } = this.props;

    return (
      <AcceptFriendship
        friendRequests={friendRequests}
        friendRequestsCounter={friendRequestsCounter}
        getFriendshipRequests={getFriendshipRequests}
        setFriendRequestsCounter={setFriendRequestsCounter}
        sfw={sfw}
        title={translate('strings.ChatRoomManager.friendBox.title')}
        updateFriendshipRequests={updateFriendshipRequests}
      />
    );
  }
}

export default NotificationsHeader;
